var map = {
	"./icons/papsi_account_number.svg": 9453,
	"./icons/papsi_address.svg": 2621,
	"./icons/papsi_age.svg": 3076,
	"./icons/papsi_apply.svg": 4100,
	"./icons/papsi_arrow_back.svg": 2585,
	"./icons/papsi_arrow_back_alt.svg": 6317,
	"./icons/papsi_arrow_forward.svg": 842,
	"./icons/papsi_avatar.svg": 2518,
	"./icons/papsi_avatar_dark.svg": 4654,
	"./icons/papsi_avatar_light.svg": 2432,
	"./icons/papsi_back.svg": 9002,
	"./icons/papsi_back_dark.svg": 7954,
	"./icons/papsi_ballot.svg": 3446,
	"./icons/papsi_branches.svg": 4721,
	"./icons/papsi_calendar.svg": 9655,
	"./icons/papsi_cancel_circle.svg": 3771,
	"./icons/papsi_check.svg": 9737,
	"./icons/papsi_check_circle.svg": 4189,
	"./icons/papsi_check_circle_filled.svg": 5560,
	"./icons/papsi_ck_off.svg": 5254,
	"./icons/papsi_ck_on.svg": 9155,
	"./icons/papsi_company.svg": 823,
	"./icons/papsi_date.svg": 4011,
	"./icons/papsi_date_of_birth.svg": 9635,
	"./icons/papsi_delete.svg": 9026,
	"./icons/papsi_device_mobile.svg": 3387,
	"./icons/papsi_device_tablet.svg": 7754,
	"./icons/papsi_dob.svg": 7930,
	"./icons/papsi_dropdown.svg": 8542,
	"./icons/papsi_dropup.svg": 7215,
	"./icons/papsi_edit.svg": 965,
	"./icons/papsi_election.svg": 9757,
	"./icons/papsi_error.svg": 9779,
	"./icons/papsi_events.svg": 6807,
	"./icons/papsi_exit.svg": 4088,
	"./icons/papsi_exit_red.svg": 6719,
	"./icons/papsi_explore.svg": 350,
	"./icons/papsi_gender_female.svg": 308,
	"./icons/papsi_gender_male.svg": 7237,
	"./icons/papsi_handshake.svg": 3767,
	"./icons/papsi_help.svg": 4976,
	"./icons/papsi_help_contact.svg": 3802,
	"./icons/papsi_help_dark.svg": 7138,
	"./icons/papsi_help_forgot.svg": 9580,
	"./icons/papsi_help_privacy.svg": 9313,
	"./icons/papsi_home.svg": 590,
	"./icons/papsi_home_dark.svg": 4556,
	"./icons/papsi_home_grey.svg": 7797,
	"./icons/papsi_info.svg": 5295,
	"./icons/papsi_info_blue.svg": 7895,
	"./icons/papsi_info_green.svg": 8139,
	"./icons/papsi_list.svg": 3935,
	"./icons/papsi_location.svg": 3818,
	"./icons/papsi_logout.svg": 184,
	"./icons/papsi_memdata.svg": 4645,
	"./icons/papsi_memtype.svg": 9771,
	"./icons/papsi_menu.svg": 6148,
	"./icons/papsi_menu_dark.svg": 5738,
	"./icons/papsi_more.svg": 219,
	"./icons/papsi_password_invisible.svg": 7426,
	"./icons/papsi_password_visible.svg": 7942,
	"./icons/papsi_pencil.svg": 6090,
	"./icons/papsi_pin.svg": 9265,
	"./icons/papsi_pnb.png": 961,
	"./icons/papsi_privacy.png": 5770,
	"./icons/papsi_recalculate.svg": 1335,
	"./icons/papsi_registered.svg": 7290,
	"./icons/papsi_reset.svg": 8216,
	"./icons/papsi_selected.svg": 2884,
	"./icons/papsi_serial.svg": 5918,
	"./icons/papsi_services.svg": 5508,
	"./icons/papsi_services_grey.svg": 948,
	"./icons/papsi_setting_auth.svg": 7145,
	"./icons/papsi_setting_deactivate.svg": 6729,
	"./icons/papsi_setting_email.svg": 2856,
	"./icons/papsi_setting_mobile.svg": 6554,
	"./icons/papsi_setting_password.svg": 2327,
	"./icons/papsi_setting_username.svg": 4383,
	"./icons/papsi_settings.svg": 1301,
	"./icons/papsi_settings_dark.svg": 8569,
	"./icons/papsi_snowman.svg": 8594,
	"./icons/papsi_spinner.svg": 451,
	"./icons/papsi_spinner_green.svg": 4830,
	"./icons/papsi_stagger.svg": 1538,
	"./icons/papsi_star_off.svg": 484,
	"./icons/papsi_star_on.svg": 1417,
	"./icons/papsi_status.svg": 4342,
	"./icons/papsi_success.svg": 8903,
	"./icons/papsi_success_green.svg": 9150,
	"./icons/papsi_summary_collapse.svg": 3624,
	"./icons/papsi_tax.svg": 1787,
	"./icons/papsi_transfer.svg": 3832,
	"./icons/papsi_upload_file.svg": 4351,
	"./icons/papsi_vote.svg": 7354,
	"./icons/selected/papsi_selected_audit.svg": 2596,
	"./icons/selected/papsi_selected_bod.svg": 2095,
	"./icons/selected/papsi_selected_elecom.svg": 4287,
	"./logo.png": 6949,
	"./styles/main.css": 3405,
	"./styles/papsi_tax.svg": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;